export const TEMPLATE_CATEGORIES = {
  ALL: 'all',
  LAYOUTS: 'layouts',
  LANDING: 'landing',
  FREE: 'free',
  BUSINESS: 'business',
  EDUCATION: 'education',
  FOOD: 'food',
  ART_MUSIC: 'art-music',
  PORTFOLIO: 'portfolio',
  SPORT: 'sport',
  TRAVEL: 'travel',
  SHOP: 'shop',
};
